/* Just Catnip PDP behaviour, ported from the inline script in spec/product.html.
   Gallery (scroll-snap strip with dots, thumbnails, arrows, keyboard), review tabs,
   video tiles, buy box state and the mobile sticky bar. */
(function () {
  'use strict';

  function initGallery(root) {
    var slides = root.querySelector('[data-slides]');
    if (!slides) return;
    var items = slides.querySelectorAll('.slide');
    var dots = root.querySelector('[data-dots]');
    var thumbs = root.querySelector('[data-thumbs]');
    var cur = 0;
    if (items.length < 2) {
      root.querySelectorAll('.gal-nav').forEach(function (b) { b.hidden = true; });
      if (dots) dots.hidden = true;
      if (thumbs) thumbs.hidden = true;
      return;
    }
    function mark() {
      [dots, thumbs].forEach(function (c) {
        if (!c) return;
        Array.prototype.forEach.call(c.children, function (b, j) { b.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
      });
    }
    /* slide geometry read from the DOM each time: robust to resizes and gaps */
    function stride() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : slides.clientWidth; }
    function go(i) {
      cur = (i + items.length) % items.length;
      slides.scrollTo({ left: stride() * cur, behavior: 'smooth' });
      mark();
    }
    [dots, thumbs].forEach(function (c) {
      if (!c) return;
      Array.prototype.forEach.call(c.children, function (b, j) { b.addEventListener('click', function () { go(j); }); });
    });
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    /* live dot tracking: read the scroll position every animation frame while the
       strip moves (no debounce, no scrollend), so the dot follows the finger */
    var ticking = false;
    slides.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.max(0, Math.min(items.length - 1, Math.round(slides.scrollLeft / stride())));
        if (i !== cur) { cur = i; mark(); }
      });
    }, { passive: true });
    slides.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(cur + 1);
      if (e.key === 'ArrowLeft') go(cur - 1);
    });
    mark();
  }

  /* curated reviews: pill tabs, max three tiles per tab in block order */
  /* review tabs + video tiles: extracted to assets/jc-reviews-tabbed.js (loaded by the section) */

  /* buy box: picks values from the JSON the snippet rendered (never computes prices).
     Two datasets share one shape: this product (base) and, on the pouch page, the Duo
     for the nudge. Each has an optional plan (pouch subscription) or starter (the
     Duo's Starter Kit); prices come as [1 pouch, 2 pouches] pairs so the cat count
     only picks an index. The Starter posts two lines through items[] inputs. */
  function initBuyBox(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var S = window.jcBuyStrings || {};
    var t = function (key, vars) { var str = S[key] || ''; Object.keys(vars || {}).forEach(function (k) { str = str.split('[' + k + ']').join(vars[k]); }); return str; };
    var readJson = function (sel) { var el = form.querySelector(sel); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
    var base = readJson('[data-jc-product]');
    if (!base) return;
    var duo = readJson('[data-jc-duo]');
    var current = base;
    var $ = function (sel) { return form.querySelector(sel); };
    var variantInput = $('[data-variant-input]'), qtyInput = $('[data-qty-input]'), planInput = $('[data-selling-plan]');
    var st = { packet: $('[data-starter-packet]'), qty: $('[data-starter-qty]'), plan: $('[data-starter-plan]'), spray: $('[data-starter-spray]'), sprayQty: $('[data-starter-spray-qty]'), prop: $('[data-starter-prop]') };
    var optSub = $('[data-opt-sub]'), optOnce = $('[data-opt-once]'), catsWrap = $('[data-cats]'), multiLine = $('[data-multi-line]'), fresh = $('[data-fresh]');
    var subName = $('[data-sub-name]'), subSub = $('[data-sub-sub]'), tag = $('[data-tag]'), perk1 = $('[data-perk-1]'), perk2 = $('[data-perk-2]');
    var was = $('[data-was]'), hero = $('[data-hero-price]'), heroNote = $('[data-hero-note]'), thenLine = $('[data-then-line]');
    var arrives = $('[data-arrives]'), aFirstLabel = $('[data-arrives-first-label]'), aFirstContents = $('[data-arrives-first-contents]'), aThenLabel = $('[data-arrives-then-label]'), aThenContents = $('[data-arrives-then-contents]');
    var oncePrice = $('[data-once-price]');
    var btnLabel = $('[data-btn-label]'), btnPrice = $('[data-btn-price]'), renew = $('[data-renew]');
    var nudge = $('[data-nudge]'), nudgeText = $('[data-nudge-text]'), nudgeBtn = $('[data-nudge-btn]');
    var section = form.closest('.shopify-section') || document;
    var barName = section.querySelector('[data-bar-name]'), barPrice = section.querySelector('[data-bar-price]'), barAdd = section.querySelector('[data-bar-add]');

    function kindOf(d) { return d.plan ? 'plan' : (d.starter ? 'starter' : null); }
    function cats() { var v = form.cats ? parseInt(form.cats.value, 10) : 1; return v === 2 ? 2 : 1; }
    function update() {
      var kind = kindOf(current);
      if (!kind && form.plan) form.plan.value = 'once';
      var subscribe = !!kind && form.plan && form.plan.value === 'subscribe';
      var i = cats() - 1;
      optSub.hidden = !kind;
      optSub.classList.toggle('selected', subscribe); optOnce.classList.toggle('selected', !subscribe);
      if (catsWrap) catsWrap.style.display = subscribe ? '' : 'none';
      /* the Catnip card's multi-cat line is always shown; the Starter Kit's helper only at 2+ */
      /* the multi-cat line is always shown on both subscription cards */
      if (multiLine) multiLine.hidden = !subscribe;
      if (fresh) fresh.style.display = subscribe ? '' : 'none';

      /* what the form posts */
      var starterMode = subscribe && kind === 'starter';
      variantInput.disabled = starterMode; qtyInput.disabled = starterMode;
      planInput.disabled = starterMode || !subscribe;
      Object.keys(st).forEach(function (k) { if (st[k]) st[k].disabled = !starterMode; });
      if (starterMode) {
        st.packet.value = current.starter.packetVariant; st.qty.value = cats(); st.plan.value = current.starter.planId; st.spray.value = current.starter.sprayVariant;
      } else {
        variantInput.value = current.variant;
        qtyInput.value = subscribe ? cats() : 1;
        planInput.value = subscribe ? current.plan.id : '';
      }

      /* subscription card: one home per fact (23 Sep 2026 copy pass) */
      if (kind === 'plan') {
        var p = current.plan;
        subName.innerHTML = t('subscribeName');
        subSub.hidden = false; subSub.innerHTML = t('subscribeSubLine');
        perk1.innerHTML = p.intro ? t('perkIntro', { pct_first: p.pctFirst, pct_sub: p.pctSub }) : t('perkPct', { pct: p.pctSub });
        perk2.innerHTML = t('perkSkip');
        arrives.hidden = true;
        tag.innerHTML = p.half ? t('mostPopularOffer', { pct: p.pctFirst }) : t('mostPopular');
        if (p.intro) {
          was.hidden = false; was.textContent = current.rrp[i];
          hero.textContent = p.first[i]; heroNote.innerHTML = t('firstDelivery');
          thenLine.innerHTML = t('thenLine', { ongoing: p.ongoing[i], cadence: p.cadence, pct: p.pctSub });
        } else {
          was.hidden = true;
          hero.textContent = p.ongoing[i]; heroNote.innerHTML = t('everyCadence', { cadence: p.cadence });
          thenLine.innerHTML = t('thenPct', { pct: p.pctSub, cadence: p.cadence });
        }
        if (multiLine) multiLine.innerHTML = t('multiLinePlan', { cadence: p.cadence });
      } else if (kind === 'starter') {
        var k = current.starter;
        subName.innerHTML = t('starterName');
        subSub.hidden = false; subSub.innerHTML = t('subscribeSubLine');
        perk1.innerHTML = t('perkStarter', { saving: k.saving[i], pct: k.pctSub });
        perk2.innerHTML = t('perkSkip');
        tag.innerHTML = k.badge[i];
        /* Duo gallery pebble mirrors the card's first-order saving live */
        section.querySelectorAll('[data-offer-saving]').forEach(function (el) { el.textContent = k.saving[i]; });
        was.hidden = false; was.textContent = k.was[i];
        hero.textContent = k.first[i]; heroNote.innerHTML = t('firstBox');
        thenLine.innerHTML = t('thenStarter', { ongoing: k.ongoing[i], cadence: k.cadence });
        arrives.hidden = false;
        aFirstLabel.innerHTML = t('arrivesFirst');
        aFirstContents.innerHTML = i ? t('arrivesFirstContentsMulti', { packet: k.packet, spray: k.spray }) : t('arrivesFirstContents', { packet: k.packet, spray: k.spray });
        aThenLabel.innerHTML = t('arrivesThen', { cadence: k.cadence });
        aThenContents.innerHTML = i ? t('arrivesThenContentsMulti', { packet: k.packet }) : t('arrivesThenContents', { packet: k.packet });
        if (multiLine) multiLine.innerHTML = t('multiLinePlan', { cadence: k.cadence });
      }
      oncePrice.textContent = current.rrp[0];

      /* button, renewal line, sticky bar */
      var title = current.title, bar;
      if (subscribe && kind === 'plan') {
        btnLabel.innerHTML = t('add');
        btnPrice.innerHTML = current.plan.intro ? t('btnFirst', { price: current.plan.first[i] }) : t('btnEvery', { price: current.plan.ongoing[i], cadence: current.plan.cadence });
        renew.hidden = false; renew.innerHTML = t('renew', { ongoing: current.plan.ongoing[i], cadence: current.plan.cadence });
        bar = current.plan.intro ? t('barFirst', { price: current.plan.first[i], ongoing: current.plan.ongoing[i], cadence: current.plan.cadence }) : t('barEvery', { price: current.plan.ongoing[i], cadence: current.plan.cadence });
      } else if (subscribe && kind === 'starter') {
        btnLabel.innerHTML = t('start');
        btnPrice.innerHTML = t('btnStarter', { price: current.starter.first[i] });
        renew.hidden = false; renew.innerHTML = t('renewStarter', { ongoing: current.starter.ongoing[i], cadence: current.starter.cadence });
        bar = t('barStarter', { price: current.starter.first[i], ongoing: current.starter.ongoing[i], cadence: current.starter.cadence });
        title = t('starterName');
      } else {
        btnLabel.innerHTML = t('add');
        btnPrice.innerHTML = t('btnOnce', { price: current.rrp[0] });
        if (renew) renew.hidden = true;
        bar = t('barOnce', { price: current.rrp[0] });
      }
      if (barName) barName.innerHTML = title;
      if (barPrice) barPrice.innerHTML = bar;

      /* nudge: a LINK to the Duo PDP carrying context (Duo routes are only ever
         chosen on the Duo PDP): subscription mode → Starter Kit preselected with the
         cat count, one-time mode → one-time preselected; lands on the buy box */
      if (nudge && duo) {
        if (nudgeBtn.tagName === 'A') {
          nudgeBtn.href = duo.url + (subscribe ? '?route=starter&cats=' + cats() : '?route=once') + '#buy';
        }
        if (current === base) {
          if (subscribe) {
            nudge.hidden = !duo.starter;
            if (duo.starter) { nudgeText.innerHTML = t('nudgeStarter', { price: duo.starter.first[i], ongoing: duo.starter.ongoing[i], cadence: duo.starter.cadence }); nudgeBtn.innerHTML = t('nudgeStarterBtn'); }
          } else {
            nudge.hidden = false;
            nudgeText.innerHTML = t('nudgeMake', { saving: t('nudgeSaveOnce', { amount: duo.saveOnce }) }); nudgeBtn.innerHTML = t('nudgeMakeBtn');
          }
        } else {
          nudge.hidden = false;
          nudgeText.innerHTML = subscribe ? t('nudgeIsStarter', { contents: duo.contents || '' }) : t('nudgeIsDuo', { title: duo.title, contents: duo.contents || '' });
          nudgeBtn.innerHTML = t('nudgeBackBtn');
        }
      }
    }
    form.addEventListener('change', update);
    /* landing context from a nudge/module link: ?route=starter|once&cats=1|2 */
    (function applyRoute() {
      var q = new URLSearchParams(location.search);
      var route = q.get('route'), c = q.get('cats');
      if (!route && !c) return;
      if (form.plan) {
        if (route === 'once') form.querySelector('input[name="plan"][value="once"]').checked = true;
        if (route === 'starter' && kindOf(current)) form.querySelector('input[name="plan"][value="subscribe"]').checked = true;
      }
      if (form.cats && (c === '1' || c === '2')) {
        var ci = form.querySelector('input[name="cats"][value="' + c + '"]'); if (ci) ci.checked = true;
      }
    })();
    if (barAdd) barAdd.addEventListener('click', function () {
      var btn = form.querySelector('[data-add-btn]');
      if (typeof form.requestSubmit === 'function') form.requestSubmit(btn); else btn.click();
    });
    update();
  }

  /* sticky bar: shows once the buy box has scrolled past (mobile only via CSS) */
  function initBuyBar(section) {
    var bar = section.querySelector('[data-buybar]'), buy = section.querySelector('#buy');
    if (!bar || !buy || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      var e = es[0];
      var visible = e.isIntersecting || e.boundingClientRect.top > 0;
      bar.classList.toggle('show', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      bar.inert = visible;
    }, { threshold: 0 }).observe(buy);
  }

  function init() {
    document.querySelectorAll('[data-jc-gallery]').forEach(initGallery);
    document.querySelectorAll('form[data-jc-buy-box]').forEach(initBuyBox);
    document.querySelectorAll('.jc-main-product-section').forEach(initBuyBar);
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
